<template>
  <tbody class="devices-info table center">
    <tr>
      <th colspan="10">设备信息</th>
    </tr>
    <tr>
      <td>机型</td>
      <td colspan="2">
        <el-input v-model.trim="details.phoneModel" :readonly="readonly" />
      </td>
      <td>IP地址</td>
      <td colspan="2">
        <el-input v-model.trim="details.ip" :readonly="readonly" />
      </td>
      <td>进件地址</td>
      <td colspan="3">
        <el-input v-model.trim="details.entryAddress" :readonly="readonly" />
        <span class="editWord cur-pointer" @click="showAddressDialog(3)">
          <svg-icon iconClass="map" />
        </span>
      </td>
    </tr>
    <slot></slot>
  </tbody>
</template>

<script>
export default {
  props: {
    details: {
      type: [Object, Array],
      default() {
        return {}
      },
      comment: '设备信息'
    },
    readonly: {
      type: Boolean,
      default: true,
      comment: '输入框是否只读'
    },
    setOpertionNum: Function
  },
  methods: {
    showAddressDialog(val) {
      this.$emit('setOpertionNum', val)
      this.$emit('input', true)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/Common/detailsTable.scss';
</style>
